import { AgreedDocs as BookingFlowAgreedDocs } from '@porterin/booking-flow/src/order-review/domain/entities/AgreedDocs';
import {
  AuthContextType as BookingFlowAuthContextType,
  User as BookingFlowUser,
} from '@porterin/booking-flow/src/order-review/view/contexts/auth/AuthContext';
import {
  AuthContextType,
  AuthUser,
} from '@porterin/feature/src/containers/login/view-model/contexts/auth-context/AuthContextV1';

export type ConvertedAuthContext = Pick<
  BookingFlowAuthContextType,
  'user' | 'setUser' | 'agreedDocs'
>;

export function authUserConverter(user: BookingFlowUser): AuthUser {
  return {
    auth_token: user.authToken,
    mobile: user.mobile,
    name: user.name,
    requirement_type: user.requirementType,
    email: user.email,
    whatsapp_consent: user.whatsappConsent,
  };
}

export function authContextConverter(
  data: AuthContextType,
): ConvertedAuthContext {
  const user: BookingFlowUser | undefined = data.user
    ? {
        authToken: data.user.auth_token,
        mobile: data.user.mobile,
        name: data.user.name,
        requirementType: data.user.requirement_type,
        email: data.user.email,
        whatsappConsent: data.user.whatsapp_consent,
      }
    : undefined;

  const agreedDocs: BookingFlowAgreedDocs | undefined = data.agreed_docs
    ? {
        agreedDocs: data.agreed_docs.agreed_docs.map(doc => ({
          docType: doc.doc_type,
          docUrl: doc.doc_url,
          createdAt: doc.created_at,
          updatedAt: doc.updated_at,
        })),
        tncUrl: data.agreed_docs.tnc_url,
        privacyPolicyUrl: data.agreed_docs.privacy_policy_url,
      }
    : undefined;

  const setUser = (nextUser?: BookingFlowUser): void => {
    data.set_user(nextUser ? authUserConverter(nextUser) : undefined);
  };

  return { user, setUser, agreedDocs };
}
